import { priceFormater } from '@/settings';
import { buildSuperscript, splitPriceForSuperscript } from './priceParts';

/**
 * Renders the cents small and raised: "$1,234" followed by a superscript ".99".
 *
 * Where to cut is locale-dependent — see splitPriceForSuperscript. A trailing
 * currency symbol is raised along with the cents (see buildSuperscript), and a
 * price with no cents to raise is handed back untouched.
 *
 * `suffix` (e.g. "/mo") is raised with the cents, so it reads as part of the
 * price: "$3" + superscript ".92/mo".
 */
export function priceFormatSuperscript(price: string, suffix = '') {
  const parts = splitPriceForSuperscript(
    price,
    priceFormater.getDecimalSeparator(),
  );

  if (!parts) {
    return `${price}${suffix}`;
  }

  return (
    <>
      {parts.head}
      {/* eslint-disable-next-line react/forbid-dom-props */}
      <sup style={{ top: '-0.4em' }}>
        {buildSuperscript(parts)}
        {suffix}
      </sup>
    </>
  );
}
